module.exports = __webpack_public_path__ + "img/terracenew_box26.2930de4c.jpg";